import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xd2o0aGV5MCB7CiAgei1pbmRleDogMjsKICBwb3NpdGlvbjogcmVsYXRpdmU7Cn0';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xd2o0aGV5MSB7CiAgcGFkZGluZy1sZWZ0OiA2cHg7CiAgZmlsbDogdmFyKC0tXzFrbWxtZzUyKTsKICBkaXNwbGF5OiBpbmxpbmU7CiAgbWFyZ2luLXRvcDogLTNweDsKfQ';
export var container = '_1wj4hey0';
export var icon = '_1wj4hey1';